import { environment } from '../../environments/environment';
import { CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class InternalOnlyGuard implements CanActivate {
    canActivate(): boolean {
        if (environment.isInternal) {
            return true;
        }

        window.location.href = '/';
        return false;
    }
}
